import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ConstructionIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "14",
        height: "18",
        viewBox: "0 0 14 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M13 16.5001C12.1496 14.1365 9.7874 12.4092 7.04724 12.4092C4.30709 12.4092 1.85039 14.1365 1 16.5001",
                stroke: "#6161FF",
                strokeWidth: "1.25",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.9528 4.22727V1.5M1.75586 6.86363H12.1495M3.07869 7.86364C3.17318 9.86364 4.87396 11.5 6.9527 11.5C9.12593 11.5 10.8267 9.86364 10.8267 7.77273V6.13636C10.8267 4.04546 9.12593 2.40909 6.9527 2.40909C4.87396 2.40909 3.17318 4.04545 3.07869 6.04545V7.86364Z",
                stroke: "#6161FF",
                strokeWidth: "1.25",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
